import { Breadcrumb, Col, Row, Select } from "antd";
import Title from "../UI/Title/Title";
import ResetButton from "../UI/ResetButton/resetbutton";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import InventorySummarList from "./inventorySummaryList";
import { useMutation, useQuery } from "react-query";
import { getInventoriesApi } from "../../api/inventorysummary";
import { getWarehousesDropdown } from "../../api/warehouse";
import { FilterInput } from "../UI/FilterApi/filterapi";
import { Search } from "../UI/Search/Search";

function InventorySummary() {
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [paginatedInventories, setPaginatedInventories] = useState<any>();
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState(1000);
  const { t } = useTranslation("common");

  const [selectedWarehouse, setSelectedWarehouse] = useState(null);

  const [formatedwearhouse, setFormatedwearhouse] = useState<{ value: string; label: string; style: any }[]>();
  
    const { isLoading: loadingwearhouse } = useQuery(
    "warehouse",
    getWarehousesDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedwearhouse(
          res.data.map((wearhouse: any) => {
            return {
              value: wearhouse.id,
              label: wearhouse.name,
            };
          })
        );
      },
    }
  );

  const resetFilters = () => {
    getInventories({
      limit: page * 10 + 10,
      q: "",
    }).then((res) => {
      setPaginatedInventories(res.data?.data);
      setSearch("");
      setFilter(undefined);
      setSelectedWarehouse(null);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    getInventories({
      limit: page * 10 + 10,
      q: search,
      isActive: filter,
    }).then((res: any) => {
      setPaginatedInventories(res.data?.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    getInventories({
      limit: page * 10 + 10,
      q: "",
      isActive: isActive,
    }).then((res: any) => {
      setPaginatedInventories(res.data?.data);
    });
  };

  const getInventories = async (params: {
    limit: number;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await InventoriesMutation(params);
  };

  const { mutateAsync: InventoriesMutation, isLoading: isInventoriesLoading } =
    useMutation("inventories", getInventoriesApi);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Row>
          <Col offset={1}>
            <Breadcrumb
              items={[
                {
                  title: <Link to="/main">{t("home")}</Link>,
                },
                {
                  title: <>{t("inventory")}</>,
                },
                {
                  title: (
                    <span className="breadcrumbcolor">
                      {t("inventory-summary")}
                    </span>
                  ),
                },
              ]}
            />
          </Col>  
        </Row>
        <Row>
          <Col offset={1}>
            <Title title={`${t("inventory-summary")}`} />
          </Col>        
        </Row>
        <Row gutter={[10, 10]}>
          <Col offset={1} style={{display:"flex"} }>
            <Select
              value={selectedWarehouse}
              onChange={(value) => setSelectedWarehouse(value)}
              loading={loadingwearhouse}
              options={formatedwearhouse}
              // key={tableKey}
              placeholder={t("warehouse")}
              style={{ width: "40%", marginRight: "5px"}}
              showSearch={true}
              size="large"
              optionFilterProp="label"
            />
            <Search
              value={search}
              onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
              onChange={(e: any) => setSearch(e.target.value)}
              onEnter={() => {
                handleSearch();
              }}
            />
            <FilterInput
              // key={tableKey}
              onChange={(value: boolean | undefined) => handleFilter(value)}
              value={filter}
            />
          </Col> 
          <Col>
          </Col>
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>                   
        </Row>
        <Row>
          <Col offset={1} span={22}>
            <InventorySummarList
              paginatedInventories={paginatedInventories}
              isInventoriesLoading={isInventoriesLoading}
              selectedWarehouse={selectedWarehouse}
              setPaginatedInventories={setPaginatedInventories}
              InventoriesMutation={InventoriesMutation}
              page={page}
              setPage={setPage}
              filter={filter}
              search={search}
              tableKey={tableKey}
            />
          </Col>
        </Row>
      </Row>

    </>
  );
}

export default InventorySummary;
